// $(document).ready(function(){
//   let $slider =  $('.block__mntn-hero-image')
// $slider.slick({
//         // autoplay: true,
//         // arrows: false,
//         // dots: false,
//         // margin: 10,
//         // slidesToShow: 1,
//         // slidesToScroll: 1,
//         // swipe: true,
//         // draggable: false,
//         // infinite: true,
//         // pauseOnHover: false,
//         // swipe: false,
//         // touchMove: false,
//         // speed: 1000,
//         // vertical: true,    
//         // useTransform: true,
//         // cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
//         // adaptiveHeight: false,
//         // pauseOnHover: false,
//         // centerMode: true,
//         // centerPadding: '0px',
//         swipe: true,
//         autoplay: true,
//         autoplaySpeed: 5000,
//         draggable: false,
//         dots: false,
//         infinite: true,
//         speed: 300,
//         slidesToShow: 1,
//         centerMode: true,
//         centerPadding: '0px',
//         arrows: false,
//         vertical: true,
//         verticalSwiping: true,
//         focusOnSelect: true,
//         adaptiveHeight: true,

//     }); 
//     $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
//         $('.block__mntn-hero-video-wrapper').removeClass('prevactive nextactive');
//         var prevSlideElement = $(slick.$slides[currentSlide]);
//         var nextSlideElement = $(slick.$slides[nextSlide + 1]);
//         prevSlideElement.addClass('prevactive');
//         nextSlideElement.addClass('nextactive');

//         playSlidevideo(); 
      
//      });
//      function playSlidevideo(){
//          var $currentSlide = $slider.find('.slick-current');
//          var $video = $currentSlide.find('video');
//          console.log("Slider ON", $currentSlide, $video, $video.length, "$video.length")
//             if ($video.length > 0 && $video[0].paused) {
//                 console.log("VIDEO FOUND")
//                 $video[0].play();
//             }
//      }
// });


$(document).ready(function () {

  let $slider = $('.block__mntn-hero-image');
 
  if (window.innerWidth > 1023) {
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true,
      verticalSwiping: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 7000,
      speed: 600,
      arrows: false,
      dots: false,
      draggable: false,
      swipe: false,
      touchMove: false,
    });
  }

  if (window.innerWidth < 1024) {
    $slider.slick({
      
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      speed: 600,
      arrows: false,
      dots: false,
      draggable: true, 
      swipe: true,
      touchMove: true,
      swipeToSlide: true,
      touchThreshold: 30,
    });
  }


  $slider.find('.slick-current').find('video')[0].play(); 
  $slider.find('.slick-current').prev().addClass('prevactive');
  $slider.find('.slick-current').next().addClass('nextactive');

    // if (window.innerWidth > 1024) {
    // setInterval(function () {
    //   $slider.slick('slickPrev');
    // }, 7000);
    // }

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.block__mntn-hero-video-wrapper').removeClass('prevactive nextactive');
        var $current = $(slick.$slides[nextSlide]);

        var $prev = $current.prev('.block__mntn-hero-video-wrapper');
        var $next = $current.next('.block__mntn-hero-video-wrapper');
          $prev.addClass('prevactive');
          $next.addClass('nextactive');
  });


  // play video after slide becomes active
  $slider.on('afterChange', function (event, slick, currentSlide) {
    playSlideVideo();
  });

  function playSlideVideo() {

    var $currentSlide = $slider.find('.slick-current');
    var $video = $currentSlide.find('video');

    if ($video.length > 0) {

     
      $slider.find('video').each(function () {
        this.pause();
        this.currentTime = 0;
      });

      
      $video[0].play().catch(function (e) {
        console.log("Autoplay prevented", e);
      });
    }
  }

});